
  import { mapState } from 'vuex'
  import moment from 'moment'

  export default {
    data() {
      return {
        selected: [],
        showFilter: false,
        showLocationPopup: false,
        showAll: []
      }
    },
    mounted() {
      // Redirect to order page if order is started
      if (
        this.order &&
        this.$route.name !== 'order' &&
        this.$route.name !== 'menu-mid' // we need the mid to set the location, handoffs and referral
      ) {
        this.$router.push(this.$route.fullPath.replace('menu','order'))
      }

      // Show popup if no location is selected
      if (!this.menu) {
        this.showLocationPopup = true
      }

      this.$nextTick(() => {
        document.addEventListener('click', (e) => {
          const filter = document.querySelector('.filter')
          if (filter) {
            if (!filter.contains(e.target)) {
              this.showFilter = false
            }
          }
        })
      })
    },
    computed: {
      ...mapState(['menu', 'location', 'defaultMenu','order', 'channel']),
      categories() {
        let menu = this.defaultMenu
        if (this.menu) {
          menu = this.menu
        }
        return menu.categories
      },
    },
    methods: {
      slug(name) {
        return name.toLowerCase().replace(/ /g, '-').replace(/'/g, '').replace(/’/g, '').trim()
      },
      name(category) {
        return category.name.split(' - ')[0]
      },
      available(category) {
        if (category.name.split(' - ')[1]) {
          return category.name.split(' - ')[1]
        }
      },
      toggle(category) {
        const index = this.selected.indexOf(category)
        if (index !== -1) {
          this.selected.splice(index, 1)
        } else {
          this.selected.push(category)
        }
      },
      availability(item) {
        let description = ''
        if (item.availability?.description) {
          description = item.availability.description
        }
        let dayWanted = moment().format('dddd')
        if (this.order && this.order.time.wanted) {
          dayWanted = moment(this.order.time.wanted, 'YYYYMMDD HH:mm').format('dddd')
        }
        const parts = description.split(',')
        for (let i = 0; i < parts.length; i++) {
          const part = parts[i]
          if (part.includes(dayWanted)) {
            description = part.trim()
            break
          }
        }
        return description
      },
      hasAvailableItems(category) {
        if (this.order && this.order.handoff) {
          let hasAvailableItems = false
          category.products.forEach((product) => {
            const unavailablehandoffmodes = product.unavailablehandoffmodes || []
            if (!unavailablehandoffmodes.includes(this.order.handoff)) {
              hasAvailableItems = true
            }
          })

          return hasAvailableItems
        } else {
          return true
        }
      },
      getImageSrc(item) {
        if (item && item.images && item.images[1]) {
          const baseUrl =
            process.env.GW_ENV === 'stage' || process.env.GW_ENV === 'prod'
              ? '//olo-images-live.imgix.net/'
              : '//olo-images-sandbox.imgix.net/';
          return baseUrl + item.images[1].filename;
        }
        return '';
      },
      goToLocations(item) {
        let currentSku = null;
        if (item && item.sku) {
          currentSku = item.sku;
          this.$store.commit('setActiveSku', currentSku);
        }
        this.$router.push('/locations');
      },
      unavailablehandoffmodes(product) {
        return product.unavailablehandoffmodes || []
      },
      toggleAll(category) {
        const name = this.slug(category.name.split(' - ')[0])
        const section = document.querySelector(`[data-category="${name}"]`)
        if (section) {
          if (this.showAll.includes(category.id)) {
            section.classList.remove('see-all')
            this.showAll = this.showAll.filter(item => item !== category.id)
          } else {
            section.classList.add('see-all')
            this.showAll.push(category.id)
          }
        }
      }
    }
  }
